import React from 'react';

type Props = {
  width: number;
  height: number;
};

const SvgIconAvatar = (props: Props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <circle
          id="path-1"
          cx="16"
          cy="16"
          r="16"
        ></circle>
      </defs>
      <g
        id="Master"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Travel---Hotel-Checkout---Returning"
          transform="translate(-312.000000, -577.000000)"
        >
          <g
            id="Personal-Info"
            transform="translate(280.000000, 542.000000)"
          >
            <g
              id="Pending-Avatar"
              transform="translate(32.000000, 35.000000)"
            >
              <mask
                id="mask-2"
                fill="white"
              >
                <circle
                  id="path-1"
                  cx="16"
                  cy="16"
                  r="16"
                ></circle>
              </mask>
              <circle
                id="path-1"
                cx="16"
                cy="16"
                r="16"
                fill="#DDDEE0"
              ></circle>
              <g
                mask="url(#mask-2)"
                fill="#6D717A"
                id="Fill-1"
              >
                <g transform="translate(0.800000, 4.800000)">
                  <path d="M30.4,25.7186795 C30.0055271,25.3584906 29.5378457,25.0598485 29.0239648,24.7968756 C28.1710505,24.3457653 27.3259545,23.87717 26.4453204,23.4701216 C25.6023567,23.0637726 24.7217227,22.721768 23.8503285,22.3699718 C23.0329522,22.025869 22.1992284,21.7090427 21.3918029,21.3579459 C21.2532043,21.2956997 21.1074981,21.1502253 21.0534802,21.0159413 C20.8679713,20.5634322 20.7123144,20.1032297 20.5744266,19.6437265 C20.4663908,19.2919304 20.39105,18.9478276 19.9333193,18.8485134 C19.8224404,18.8296297 19.6866849,18.6310013 19.6674943,18.5065088 C19.5665661,17.8294935 19.501176,17.1615704 19.456398,16.4754631 C19.4471581,16.3390808 19.5196558,16.1586367 19.6113441,16.0404388 C20.2169133,15.3823072 20.5481284,14.6150699 20.6845947,13.7387268 C20.7599355,13.3071996 21.0065699,12.891059 21.1352178,12.4588323 C21.3093545,11.8811313 21.4479531,11.285246 21.5837086,10.6977534 C21.6306189,10.4900328 21.6028992,10.2543364 21.6405695,10.0396218 C21.6846368,9.7227955 21.6753969,9.47800693 21.2901639,9.35281506 C21.1799958,9.31574708 21.0975474,9.07375609 21.0883075,8.90939805 C21.0698277,7.97080873 21.0883075,7.03291881 21.0790676,6.08523735 C21.0790676,5.50753632 21.0790676,4.9298353 21.0442403,4.35213427 C20.952552,3.24079417 20.2993617,2.4644647 19.4656379,1.78744946 C18.2630287,0.811792155 16.8592738,-0.107913472 15.3375324,0.010284437 L15.3354002,0.010284437 C15.3147881,0.0116832289 15.2948867,0.0081862493 15.2742746,0.010284437 C15.2465549,0.010284437 15.2245213,0.0172783962 15.2003554,0.0235729594 C15.1754787,0.0172783962 15.1534451,0.010284437 15.1257254,0.010284437 C15.1051133,0.0081862493 15.0852119,0.0116832289 15.0645998,0.010284437 L15.0631783,0.010284437 C13.541437,-0.107913472 12.1369713,0.811792155 10.9343621,1.78744946 C10.1006383,2.4644647 9.4481588,3.24079417 9.35647051,4.35213427 C9.32093241,4.9298353 9.32093241,5.50753632 9.32093241,6.08523735 C9.3116925,7.03291881 9.33017231,7.97080873 9.3116925,8.90939805 C9.3024526,9.07375609 9.22000421,9.31574708 9.1098361,9.35281506 C8.72460312,9.47800693 8.71536321,9.7227955 8.75943046,10.0396218 C8.79710084,10.2543364 8.76938112,10.4900328 8.81629141,10.6977534 C8.95204695,11.285246 9.09064553,11.8811313 9.26478221,12.4588323 C9.39414089,12.891059 9.64077529,13.3071996 9.7154053,13.7387268 C9.8518716,14.6150699 10.1830867,15.3823072 10.7886559,16.0404388 C10.8803442,16.1586367 10.9535526,16.3390808 10.943602,16.4754631 C10.8995347,17.1615704 10.8334339,17.8294935 10.7325057,18.5065088 C10.7140259,18.6310013 10.5775596,18.8296297 10.4673915,18.8485134 C10.00895,18.9478276 9.93431998,19.2919304 9.82628416,19.6437265 C9.68768558,20.1032297 9.53273947,20.5634322 9.3472306,21.0159413 C9.29321269,21.1502253 9.14750649,21.2956997 9.0089079,21.3579459 C8.20077155,21.7090427 7.36704777,22.025869 6.54967151,22.3699718 C5.67827734,22.721768 4.79764326,23.0637726 3.95467957,23.4701216 C3.0740455,23.87717 2.22894952,24.3457653 1.37603516,24.7968756 C0.862154263,25.0598485 0.394472891,25.3584906 0,25.7186795 L0,27.1979018 L11.3871174,27.1979018 L11.3871174,27.2 L18.7172056,27.2 L18.7172056,27.1979018 L30.4,27.1979018 L30.4,25.7186795 Z"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SvgIconAvatar;
